import React from 'react';
import Article from './Article';

interface ReportListProps {
  posts: any[];
  pdf: any;
}

export default function ReportList({ posts, pdf }: ReportListProps) {
  return (
    <>
      <div className="md:max-w-xl lg:max-w-4xl xl:max-w-6xl mx-auto my-16 px-8 lg:px-0">
        <h2 className="text-center text-blue-700 font-semibold sm:text-3xl text-2xl">
          Presentación
        </h2>
        <p className="leading-6 mt-8 xl:max-w-4xl text-justify">
          Reporte Imagenológico Dentomaxilofacial es una revista orientada hacia
          la presentación de experiencias en Radiología e Imagenología
          Dentomaxilofacial mediante la descripción de casos de interés para
          estudiantes, académicos y profesionales de la Odontología en todas sus
          especialidades, con énfasis en el diagnóstico diferencial del mismo,
          la obtención y análisis de las imágenes.
        </p>
        <p className="leading-6 my-2 xl:max-w-4xl text-justify">
          La Sociedad Venezolana de Radiología e Imagenología Dentomaxilofacial
          los invita a participar activamente enviando a esta tribuna sus casos
          y de esta manera contribuir a abrir espacios para la difusión de
          saberes en esta disciplina de la Odontología.
        </p>
        <p className="leading-6 my-2 xl:max-w-4xl text-justify">
          Atentamente,
          <br />
          Por el Comité Editorial.
          <span className="my-2 block">
            Editora Jefe
            <br />
            Dra. Ana I. Ortega-Villalobos
            <br />
            Universidad del Zulia. Maracaibo, Venezuela.
          </span>
          <span className="my-2 block">
            Dr. Claudio Fróes De Freitas
            <br />
            Universidad Ciudad de São Paulo - UNICID. São Paulo, Brasil.{' '}
          </span>
          <span className="my-2 block">
            Dra. Maira Quevedo-Piña
            <br />
            Universidad de Carabobo. Valencia, Venezuela.
          </span>
          <span className="my-2 block">
            Dr. Alejandro Hidalgo
            <br />
            Universidad de Talca. Talca, Chile.
          </span>
          <span className="my-2 block">
            Dra. Adriana Poletto
            <br />
            Universidad Nacional del Cuyo. Mendoza, Argentina
          </span>
        </p>
        <p className="mb-2">Depósito legal: CA2021000033</p>
        <a
          className="text-blue-700 inline-flex items-center mb-4 cursor-pointer mx-auto"
          href={pdf.node.publicURL}
          download
        >
          Descargar Normas de Publicación{' '}
          <svg fill="currentColor" className="w-4 h-4 ml-2" viewBox="0 0 20 20">
            <path
              fillRule="evenodd"
              d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
        </a>
      </div>
      <div className="text-gray-600 body-font">
        <h3 className="text-center text-gray-700 font-semibold sm:text-3xl text-2xl">
          Reportes Publicados
        </h3>
        <div className="container px-5 py-16 mx-auto">
          <div className="flex flex-wrap -m-4">
            {posts.map((post) => (
              <div className="p-4 md:w-1/3" key={post.fields.slug}>
                <Article post={post} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
